document.addEventListener('DOMContentLoaded', function() {
  if (window.matchMedia('(max-width: 749px)').matches) {
    const collapsible = document.querySelectorAll('.is-collapsible .footer-block__heading');
    console.log("collapsible", collapsible);
    
    collapsible?.forEach(function(heading) {
      heading.addEventListener('click', function() {
        var parent = heading.closest('.is-collapsible');
        parent.classList.toggle('active');
      });
    });
  }
}); 